import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import {
  ConfigService,
  RouterService,
} from '@gen-epix/ui';

export const HomePageIntroduction = () => {
  const [t] = useTranslation();
  const onExploreCasesButtonClick = useCallback(async () => {
    await RouterService.getInstance().router.navigate('/cases');
  }, []);

  return (
    <Box>
      <Box sx={{ marginY: 1 }}>
        <Typography variant={'h1'}>
          {t('Welcome to {{applicationName}}', { applicationName: ConfigService.getInstance().config.applicationName })}
        </Typography>
      </Box>
      <Box sx={{ marginY: 1 }}>
        <Typography>
          {t`Whether you're a MML expert, GGD expert or a RIVM PH expert, LabSentiNL is designed to meet your data needs for sharing and exploring and will help you stay ahead in an ever-evolving landscape. On this website you can discover the latest events, have a look at interesting statistics or start exploring various case types.`}
        </Typography>
      </Box>
      <Box sx={{ marginY: 1 }}>
        <Button
          color={'secondary'}
          onClick={onExploreCasesButtonClick}
        >
          {t`Start exploring the cases`}
        </Button>
      </Box>
      <Box sx={{ marginY: 2 }}>
        <Alert severity={'info'}>
          <AlertTitle>
            {t`Important: phased rollout of data`}
          </AlertTitle>
          <br />
          <Typography>
            {t`LabSentiNL is being introduced in phases. At launch, the platform contains data for a limited number of pathogens. In the coming weeks, additional pathogens and case data will be added step by step.`}
          </Typography>
          <br />
          <Typography>
            {t`As a result, the current overview may not yet reflect the full scope of laboratory surveillance in the Netherlands. The absence of specific pathogens or low case numbers does not mean these are not monitored (in the near future) within LabSentiNL.`}
          </Typography>
        </Alert>
      </Box>
    </Box>
  );
};
